<template>
  <div v-if="show" v-rect-loading="loading" class="ai-interview-room-list">
    <div class="content">
      <div class="title">{{ $t(`${i18nPrefix}.label.selectJobInterviewRoom`) }}</div>
      <el-select v-model="selectedInterviewRoom" class="select-interview-room" :disabled="disabled">
        <el-option
          v-for="item in interviewRoomList"
          :key="item.interview_room_id"
          :label="item.name"
          :value="item.interview_room_id"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'
import { mapActions } from 'vuex'

export default {
  mixins: [mixin],
  data () {
    return {
      loading: false,
      hasForm: false,
      interviewRoomList: [],
      selectedInterviewRoom: null
    }
  },
  computed: {
    companyId () {
      return this.jobInfo?.company?.id
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('interview', ['getAIInterviewRoomList', 'getJobInterviewRoomInfo']),
    initPage () {
      this.loadInterviewRoomList()
      this.loadJobInterviewRoomInfo()
    },
    async loadInterviewRoomList () {
      if (!this.companyId) {
        return
      }
      this.loading = true
      try {
        const resp = await this.getAIInterviewRoomList(this.companyId)
        if (resp) {
          this.interviewRoomList = resp
        }
      } finally {
        this.loading = false
      }
    },
    async loadJobInterviewRoomInfo () {
      if (!this.jobInfo.id) {
        return
      }
      const resp = await this.getJobInterviewRoomInfo(this.jobInfo.id)
      if (resp) {
        this.selectedInterviewRoom = resp.interview_room_id
      }
    },
    async setStepDataToJobInfo () {
      const jobInfo = this.jobInfo
      this.$set(jobInfo, 'interview_room_id', this.selectedInterviewRoom)
    },
    async getStepData () {
      const jobInfo = this.jobInfo
      const stepData = {
        interview_room_id: jobInfo.interview_room_id
      }
      return stepData
    }
  },
  watch: {
    companyId: {
      handler () {
        this.loadInterviewRoomList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-interview-room-list {
  .content {
    display: flex;
    align-items: center;
    .title {}
    .select-interview-room {
      flex: 1;
      margin-left: 16px;
    }
  }
}
</style>
